import { query } from "../db.js";

async function getUserSession(userId) {
    const { rows } = await query(
        `SELECT * FROM wa_sessions WHERE user_id = $1 LIMIT 1`,
        [userId]
    );
    return rows[0] || null;
}

async function getUserDeviceSession(sessionId) {
    const { rows } = await query(
        `SELECT * FROM whatsapp_sessions WHERE session_id = $1 LIMIT 1`,
        [sessionId]
    );
    return rows[0] || null;
}

async function setUserSession(userId, state, data = {}) {
    const existing = await getUserSession(userId);

    if (existing) {
        return await query(
            `UPDATE wa_sessions SET state = $1, data = $2, updated_at = NOW() WHERE user_id = $3`,
            [state, data, userId]
        );
    } else {
        return await query(
            `INSERT INTO wa_sessions (user_id, state, data) VALUES ($1, $2, $3)`,
            [userId, state, data]
        );
    }
}

async function clearUserSession(userId) {
    return await query(`DELETE FROM wa_sessions WHERE user_id = $1`, [userId]);
}

async function getMenuConfig(sessionId) {
    const { rows } = await query(
        `SELECT * FROM whatsapp_menu_configs WHERE session_device_id = $1 LIMIT 1`,
        [sessionId]
    );
    return rows[0] || null;
}

async function getMenuItems(sessionId) {
    const { rows } = await query(
        `SELECT * FROM whatsapp_menu_items WHERE session_device_id = $1`,
        [sessionId]
    );
    return rows || [];
}

function isSessionExpired(updatedAt) {
    const now = new Date();
    const updated = new Date(updatedAt);
    const diffMins = (now - updated) / 60000;
    return diffMins > 5;
}

async function getDeviceAutoReadSetting(sessionDeviceId) {
    const { rows } = await query(
        `SELECT auto_read_enabled FROM devices WHERE session_device_id = $1 LIMIT 1`,
        [sessionDeviceId]
    );

    // Default to true if column doesn't exist or device not found (maintain current behavior)
    const data = rows[0];
    return data?.auto_read_enabled !== undefined && data?.auto_read_enabled !== null
        ? data.auto_read_enabled
        : true;
}

export {
    getUserSession,
    setUserSession,
    clearUserSession,
    getMenuItems,
    getMenuConfig,
    isSessionExpired,
    getUserDeviceSession,
    getDeviceAutoReadSetting,
};
